var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":_vm.id,"data-type":_vm.type,"data-url":_vm.url,"data-pk":_vm.pk,"data-showbuttons":_vm.showButton,"data-inputclass":_vm.className,"data-mode":_vm.mode,"data-value":_vm.value,"data-emptytext":_vm.emptyText,"data-title":_vm.title}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d054da6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/vendor/x-editable/editable.vue
// module id = KjGg
// module chunks = 1